import React                                     from 'react';
import { formatOption }                          from '../../../../util';
import { ACTIVITY_STATUS, ACTIVITY_STATUS_INFO } from '../../../../constants/ProductEnums';
import { SelectField }                           from '../../../components/forms';
import { useProjectTermDictionary }              from '../../../../hooks/useTermDictionary';

const Dropdown = ( props ) => {
	
	let { getTerm } = useProjectTermDictionary();
	
	let options = [
		formatOption( ACTIVITY_STATUS.NOTSTARTED, getTerm( ACTIVITY_STATUS_INFO.NOTSTARTED.LABEL ) ),
		formatOption( ACTIVITY_STATUS.INCOMPLETE, getTerm( ACTIVITY_STATUS_INFO.INCOMPLETE.LABEL ) ),
		formatOption( ACTIVITY_STATUS.COMPLETE, getTerm( ACTIVITY_STATUS_INFO.COMPLETE.LABEL ) ),
		formatOption( ACTIVITY_STATUS.EXCLUDED, getTerm( ACTIVITY_STATUS_INFO.EXCLUDED.LABEL ) ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as CompletionStatusDropdown };
